// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-selected-item[data-v-5ece293e] {\n  background-color: var(--v-accent-base);\n}\n.v-snack__action[data-v-5ece293e] {\n  align-self: start;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
